export interface InputItem {
  readonly type: 'input';
}

export interface TextItem {
  readonly type: 'text';
  readonly content: string;
}

export interface OpenEndedQuestionParagraph {
  readonly items: readonly (InputItem | TextItem)[];
}

export interface InlineOpenEndedQuestionModel {
  readonly paragraphs: readonly OpenEndedQuestionParagraph[];
}

/******************************************************************************/

export function positionToItemId(paragraph: number, index: number) {
  return paragraph.toString(10) + '/' + index.toString(10);
}
